<template>
	<div class="graph-nd graph-1d">
		<svg :viewBox="'0 0 ' + width + ' ' + height" xmlns="http://www.w3.org/2000/svg">
			<Legend v-bind:width="width"
				v-bind:height="height"
				v-bind:startDate="startDate"
				v-bind:bins="bins.length"
				v-bind:binWidth="binWidth">
			</Legend>

			<g v-for="(bin, index) in bins" :key="index"
				class="tooltip-trigger"
				@click="showTooltip(bin, ...arguments)"
				@mouseover="showTooltip(bin, ...arguments)"
				@mouseout="hideTooltip">

				<g v-if="bin.length > 0">
					<circle :cx="centerScaleX(index)"
							:cy="height / 2 - 30"
							:r="10"
							fill="white"
							stroke="rgb(42, 66, 77)">
					</circle>
					<text :x="centerScaleX(index)"
						  :y="height / 2 - 26"
						  :style="{ fill: 'rgb(42, 66, 77)', fontSize: 12 }"
						  text-anchor="middle">
						  {{ binTotal(bin) }}
					</text>
				</g>

			</g>
		</svg>

		<Tooltip v-bind:display="tooltipDisplay" @hover="hoverTooltip">
			<p v-for="(point, i) in tooltipBin" :key="i">
				<strong>{{ formatMedicineCount(point.value) }}</strong><br>
				<small>{{ formatDateTime(point.time) }}</small>
			</p>
		</Tooltip>
	</div>
</template>

<script>
import Graph from '.'
import Legend from './component/Legend'

export default {
	name: 'count-graph-1d',
	extends: Graph,

	computed: {
		/**
		 * @function 	bins
		 * @desc 		Bins the data points into day-wide bins for the interval determined by the current scale
		 */
		bins() {
			var bins = []

			for (var t = this.startDate.getTime() ; t <= this.date.getTime() ; t += this.binInterval) {
				bins.push(this.data.filter((point) => (t <= point.time && point.time <= t + this.binInterval)))
			}

			return bins
		}
	},
	methods: {
		setScale(scale) {
			this.scale = scale
		},
		scaleX(x) {
			return x * this.width / this.bins.length
		},
		/**
		 * @function 	centerScaleX
		 * @desc 		
		 * @param 		{x} Number
		 */
		centerScaleX(x) {
			return (x + 0.5) * this.width / (this.bins.length + 1)
		},

		/**
		 * @function 	binDate
		 * @desc 		get bin's date resepctive to the index given as parameter
		 * @param 		{index} Number
		 */
		binDate(index) {
			return new Date(this.startDate.getTime() + this.binInterval * index)
		},

		/**
		 * @function 	binTotal
		 * @desc 		total of all values lying in the bin passed as parameter
		 * @param 		{index} Number
		 */
		binTotal(bin) {
			return bin.map((point) => point.value).reduce((a, b) => a + b, 0)
		},
		formatMedicineCount(count) {
			if(count === 1) {
				return '1 time'
			} else {
				return count + ' times'
			}
		}
	},
	  components: {
		  Legend
	}
}
</script>

<style lang="scss" scoped>
.graph-1d {
	background-color: #ffffff;
}
</style>
